import { Box, Image } from "@chakra-ui/react";
import coinRight from "../images/fireworks-right.png";
import coinLeft from "../images/fireworks-left.png";
import { isExpiredNewYear } from "../utils";

/**
 * @description 煙火(右向)
 * @returns {JSX.Element}
 */
export const FireworksRight = ({ sx }) => {
  // 如果新年裝飾已過期，則不顯示任何裝飾物
  if (isExpiredNewYear()) return null;

  return (
    <Box
      pointerEvents={"none"}
      position={"absolute"}
      display={{ base: "none", lg: "block" }}
      sx={sx}
    >
      <Image src={coinRight} />
    </Box>
  );
};

/**
 * @description 煙火(左向)
 * @returns {JSX.Element}
 */
export const FireworksLeft = () => {
  return (
    <Box
      pointerEvents={"none"}
      position={"absolute"}
      top={"-5rem"}
      right={"-15rem"}
      display={{ base: "none", lg: "block" }}
    >
      <Image src={coinLeft} />
    </Box>
  );
};
